import { Route, Switch } from "react-router";
import { VisitTypesMainPage } from "Pages/VisitTypes/MainPage/MainPage";
import { VisitTypeEditorPage } from "Pages/VisitTypes/Editor/EditorPage";
import { VISIT_TYPES, VISIT_TYPE_EDITOR_PATH } from "Constants/Views";

export default function VisitTypes() {
  return (
    <Switch>
      <Route
        exact
        path={VISIT_TYPE_EDITOR_PATH}
        render={() => <VisitTypeEditorPage />}
      />
      <Route exact path={VISIT_TYPES} render={() => <VisitTypesMainPage />} />
    </Switch>
  );
}
